// src/component/ui/HomeStats.jsx
// Bande de statistiques avec compteurs animés (chiffres à ajuster selon la réalité).
import React from "react";
import CountUp from "./CountUp";
import { FaBoxes, FaTruck, FaTags, FaUsers } from "react-icons/fa";
import "./homeStats.css";

const STATS = [
  { icon: <FaBoxes />,  end: 50000, suffix: "+", label: "Références en catalogue" },
  { icon: <FaTags />,   end: 40,    suffix: "+", label: "Marques d'origine & adaptables" },
  { icon: <FaTruck />,  end: 24,    suffix: "h", label: "Livraison express" },
  { icon: <FaUsers />,  end: 1200,  suffix: "+", label: "Revendeurs partenaires" },
];

export default function HomeStats() {
  return (
    <section className="hs" aria-label="Chiffres clés">
      <div className="hs__inner">
        {STATS.map((s, i) => (
          <div className="hs__item" key={i} style={{ transitionDelay: `${i * 80}ms` }}>
            <div className="hs__icon">{s.icon}</div>
            <div className="hs__num">
              <CountUp end={s.end} suffix={s.suffix} />
            </div>
            <div className="hs__label">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
